import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_3 = {
  class: "demonstration",
  style: {
    "margin": "10px 0"
  }
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.add,
        style: {
          "position": "relative",
          "left": "0px"
        }
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("添加要求", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.goBack,
        style: {
          "position": "relative",
          "left": "-10px"
        }
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("上一步", -1)]))]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }), _createVNode(_component_el_main, {
      style: {
        "margin-top": "-25px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.tableData,
        style: {
          "width": "100%",
          "height": "475px"
        },
        border: "",
        "row-class-name": $options.tableRowClassName
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "5%"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "small",
            onClick: $event => $options.update(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            plain: "",
            size: "small",
            style: {
              "margin-left": "3px"
            },
            onClick: $event => $options.deleteOne(scope.row.askId)
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ifTrue",
          "min-width": "5%",
          label: "要求序号"
        }), _createVNode(_component_el_table_column, {
          prop: "askName",
          "min-width": "30%",
          label: "要求名称"
        })]),
        _: 1
      }, 8, ["data", "row-class-name"])]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
        currentPage: $data.currentPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => $data.currentPage = $event),
        "page-size": $data.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => $data.pageSize = $event),
        "page-sizes": [20, 40, 60],
        small: $data.small,
        background: $data.background,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        prev: $data.prev,
        pager: $data.pager,
        next: $data.next,
        jumper: $data.jumper,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.dialogFormVisible = $event),
    title: "添加要求",
    "lock-scroll": false,
    width: "45%",
    style: {
      "margin-top": "30px"
    },
    draggable: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      onClick: _cache[4] || (_cache[4] = $event => $data.dialogFormVisible = false)
    }, {
      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      type: "primary",
      onClick: _cache[5] || (_cache[5] = $event => $options.save('form'))
    }, {
      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("确认", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.form,
      ref: "form",
      rules: $data.rules,
      "status-icon": "",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "要求名称",
        prop: "askName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.askName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.askName = $event),
          "show-word-limit": "",
          clearable: "",
          autosize: {
            minRows: 4,
            maxRows: 8
          },
          style: {
            "width": "300px"
          },
          type: "textarea",
          maxlength: "1000"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "要求序号",
        prop: "ifTrue"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.ifTrue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.ifTrue = $event),
          "show-word-limit": "",
          clearable: "",
          style: {
            "width": "300px"
          },
          maxlength: "50"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisibleEdit,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.dialogFormVisibleEdit = $event),
    title: "编辑要求 ",
    "lock-scroll": false,
    width: "45%",
    style: {
      "margin-top": "30px"
    },
    draggable: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      onClick: _cache[9] || (_cache[9] = $event => $data.dialogFormVisibleEdit = false)
    }, {
      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      type: "primary",
      onClick: _cache[10] || (_cache[10] = $event => $options.edit('editform'))
    }, {
      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.editform,
      ref: "editform",
      rules: $data.rules,
      "status-icon": "",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "要求名称",
        prop: "askName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editform.askName,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.editform.askName = $event),
          "show-word-limit": "",
          clearable: "",
          autosize: {
            minRows: 4,
            maxRows: 8
          },
          style: {
            "width": "300px"
          },
          type: "textarea",
          maxlength: "1000"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "要求序号",
        prop: "ifTrue"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editform.ifTrue,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.editform.ifTrue = $event),
          "show-word-limit": "",
          clearable: "",
          style: {
            "width": "300px"
          },
          maxlength: "50"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"])]);
}